export function getToken() {
    try {
        const auth = localStorage.getItem('auth');
        if (!auth) return null;
        
        const parsedAuth = JSON.parse(auth);
        return parsedAuth?.token || null;
    } catch (error) {
        console.error('Error parsing auth token:', error);
        return null;
    }
}

export function clearToken() {
    localStorage.removeItem('auth');
    localStorage.removeItem('userIdentity');
}

/**
 * Get Authorization header with current token
 * MUST be a getter function - not a constant - to always read fresh token
 */
function getAuthorizationHeader() {
    const token = getToken();
    if (!token) return {};
    return { Authorization: `Bearer ${token}` };
}

// Export as default - will be called as Authorization() in API modules
export default getAuthorizationHeader;
